"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveScheduledEmail = void 0;
// (C) 2020-2021 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../model");
exports.useSaveScheduledEmail = function (_a) {
    var _b = _a === void 0 ? {} : _a, onBeforeRun = _b.onBeforeRun, onSuccess = _b.onSuccess, onError = _b.onError;
    var scheduledEmailCommandProcessing = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.saveScheduledEmail,
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        successEvent: "GDC.DASH/EVT.SCHEDULED_EMAIL.SAVED",
        onError: function (event) {
            onError === null || onError === void 0 ? void 0 : onError(event.payload.error);
        },
        onSuccess: function () {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        },
        onBeforeRun: function (cmd) {
            onBeforeRun === null || onBeforeRun === void 0 ? void 0 : onBeforeRun(cmd.payload.scheduledEmail);
        },
    });
    var save = react_1.useCallback(function (scheduledEmailToSave, filterContextRef) {
        scheduledEmailCommandProcessing.run(scheduledEmailToSave, filterContextRef);
    }, []);
    return {
        save: save,
        savingStatus: scheduledEmailCommandProcessing.status,
    };
};
//# sourceMappingURL=useSaveScheduledEmail.js.map